import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  IconButton,
  Card,
  CardContent,
  ListItemSecondaryAction,
  Tooltip,
} from '@material-ui/core';

import {
  grey,
} from '@material-ui/core/colors'

class StageListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      selectedStageID: -1,
      targetStageId: -1,
    };
    autoBind(this);

    this.refresh();
  }

  refresh() {
    let requestObj = {
      locale_id: this.props.parent.props.localeData['id'],
    };
    this.props.root.refs.API.request("get_stage_list_by_locale_id", requestObj, this.getStageListOK, this.getStageListFailed);
  }

  getStageListOK(res) {
    this.props.parent.setState({
      stageList: res.body['result'],
    });

    if (this.state.selectedStageID < 0 && res.body['result'].length > 0) {
        this.props.parent.refresh(res.body['result'][0]['id']);
    }
    else {
      this.props.parent.refreshOK();
    }
  }

  getStageListFailed(err) {
    console.log("get stage list failed");
  }

  handleStageClicked(index, stage_id) {
    this.selectStage(stage_id);
    this.props.parent.selectStageById(stage_id);
  }

  selectStage(stage_id) {
    this.setState({
      selectedStageID: stage_id,
    });
    this.state.selectedStageID = stage_id;
  }

  moveUpContentClicked(index) {
    if (index > 0) {
      this.swapStageDataDisplayOrder(this.props.parent.state.stageList[index], this.props.parent.state.stageList[index-1]);
    }
  }

  moveDownStageClicked(index) {
    if(index < this.props.parent.state.stageList.length - 1) {
      this.swapStageDataDisplayOrder(this.props.parent.state.stageList[index], this.props.parent.state.stageList[index+1]);
    }
  }

  swapStageDataDisplayOrder(stageData1, stageData2) {
    let requestObj = {};
    requestObj['stage_id_1'] = stageData1['id'];
    requestObj['stage_id_2'] = stageData2['id'];
    this.props.root.refs.API.request("swap_display_order", requestObj, this.swapStageDataDisplayOrderOK, this.swapStageDataDisplayOrderFailed);
  }

  swapStageDataDisplayOrderOK(res) {
    this.refresh();
  }

  swapStageDataDisplayOrderFailed(err) {
    console.log("swap stage data display order failed");
  }

  deleteStageClicked(id) {
    this.setState({
      targetStageId: id,
    });
    this.state.targetStageId = id;

    let dialogText = {
      title: Localization.strings.DELETE_STAGE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteStageConfirmClicked, this.deleteStageCancelClicked);
  }

  deleteStageConfirmClicked() {
    let requestObj = {
      stage_id: this.state.targetStageId,
    };
    this.props.root.refs.API.request("delete_stage", requestObj, this.deleteStageOK, this.deleteStageFailed);
  }

  deleteStageCancelClicked() {

  }

  deleteStageOK(res) {
    this.props.root.addNotification(Localization.strings.DELETED);
    if (this.state.targetStageId == this.props.parent.refs.stageDetailView.state.stageData['id']) {
      this.setState({ selectedStageID: -1 });
      this.state.selectedStageID = -1;
      this.props.parent.selectStageById(-1);
    }
    this.refresh();
  }

  deleteStageFailed(err) {
    console.log("delete stage failed");
  }

  render() {
    let stageList = this.props.parent.state.stageList;

    return (
      <div style={{maxHeight:this.props.parent.state.maxHeight, overflow:'auto'}}>
        <If condition={stageList.length > 0}>
          <Then>
            <List style={{padding:"0"}}>
              {stageList.map( (row, i) => {
                let iconString = "";
                if (row['kind'] == 0) {
                  iconString = "movie";
                }
                else if (row['kind'] == 1) {
                  iconString = "photo";
                }

                return (
                  <Card variant="outlined" className="margin-std padding-sm" >
                    <CardContent className="padding-zero">
                      <ListItem
                        button
                        key={row['id']}
                        onClick={() => this.handleStageClicked(i, row['id'])}
                        selected={row['id'] == this.state.selectedStageID}
                      >
                        <ListItemIcon><Icon>{iconString}</Icon></ListItemIcon>
                        <ListItemText>{row['stage_name']}</ListItemText>
                        <ListItemSecondaryAction>
                          <If condition={i > 0}>
                            <Then>
                              <Tooltip title={Localization.strings.MOVE_UP}>
                                <IconButton
                                  onClick={()=>this.moveUpContentClicked(i)}
                                >
                                  <Icon style={{ color: grey[700] }}>arrow_upward</Icon>
                                </IconButton>
                              </Tooltip>
                            </Then>
                          </If>
                          <If condition={i < stageList.length-1}>
                            <Then>
                              <Tooltip title={Localization.strings.MOVE_DOWN}>
                                <IconButton
                                  onClick={()=>this.moveDownStageClicked(i)}
                                >
                                  <Icon style={{ color: grey[700] }}>arrow_downward</Icon>
                                </IconButton>
                              </Tooltip>
                            </Then>
                          </If>
                          <Tooltip title={Localization.strings.DELETE}>
                            <IconButton
                              onClick={()=>this.deleteStageClicked(row['id'])}
                            >
                              <Icon style={{ color: grey[700] }}>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </CardContent>
                  </Card>
                );
              })}
            </List>
          </Then>
          <Else>
            <Card style={{margin: "10px"}}>
              <CardContent>
                No stage has been created yet. Click + NEW STAGE to create at least one in your VITALS.
              </CardContent>
            </Card>
          </Else>
        </If>
      </div>
    )
  }
}

export default StageListView;
